import { makeDeamonUrl, makeHttpClient } from '../../http';
import { Sign as UseCasesRemoteSign } from '~/domain/usecases/deamon/remote';

import { RemoteSignDocument } from '~/data/repository/deamon';

export const makeRemoteSignDocument = (): UseCasesRemoteSign =>
  new RemoteSignDocument(makeDeamonUrl('/sign'), makeHttpClient());
